<template>
  <div class="moreSearch">
    <el-popover
      placement="bottom-start"
      width="558"
      trigger="click"
      popper-class="my-popover"
      v-model="visible"
    >
      <div class="lyout">
        <div class="cond">
          <el-button @click="addBut" v-if="addButt">添加排序条件</el-button>
        </div>
        <div class="main" v-if="!addButt">
          <div
            class="main-first"
            v-for="(item, index) in orderJson"
            :key="index"
          >
            <div class="sele-fist">
              <el-select v-model="item.key" @focus="focusChange(item)" @change="selectChange(item)" placeholder="请选择">
                <el-option
                  v-for="key in item.optionsKey"
                  :key="key.value"
                  :label="key.label"
                  :value="key.value"
                />
              </el-select>
            </div>
            <div class="sele-secon">
              <el-select v-model="item.sort" placeholder="请选择">
                <el-option
                  v-for="sort in sequence"
                  :key="sort.value"
                  :label="sort.label"
                  :value="sort.value"
                />
              </el-select>
            </div>
            <div class="sele-icon">
              <i @click="delCond(index)" class="iconfont icon-checkbox-minus" />
              <i @click="addCond" class="iconfont icon-checkbox-plus" />
            </div>
          </div>
          <div class="footer" v-if="!addButt">
            <div>
              <el-button @click="reset">取消</el-button>
              <el-button type="primary" @click="screening">确定</el-button>
            </div>
          </div>
        </div>
      </div>
      <div slot="reference" class="more_btn">
        <el-button :type="addButt?'info':'primary'" plain icon="el-icon-my-export">
          <i class="el-icon-sort el-icon--left" />
          <span>排序</span>
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    // 接受 参数
    state: {
      type: String,
      default: ''
    },
    sorting: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      visible: false,
      // 点击添加按钮
      addButt: true,
      // 排序
      orderJson: [],
      // 正序倒叙
      sequence: [
        {
          value: 'asc',
          label: '正序'
        },
        {
          value: 'desc',
          label: '倒序'
        }
      ]
    }
  },
  watch: {
    sorting: {
      handler() {
        if (this.sorting && this.sorting.length > 0) {
          this.orderJson = []
          this.sorting.map((item) => {
            this.orderJson.push(item)
          })
          this.addButt = false
        } else {
          this.orderJson = []
          this.addButt = true
        }
      }
    }
  },
  methods: {
    // 点击添加按钮
    addBut() {
      var optionsKey = []
      //  subject：项目；task：任务
      if (this.state === 'subject') {
        optionsKey = [
          {
            value: 'status',
            label: '项目状态'
          },
          {
            value: 'principalUser',
            label: '负责人'
          },
          {
            value: 'planStartDate',
            label: '计划开始时间'
          },
          {
            value: 'planEndDate',
            label: '计划截止时间'
          },
          {
            value: 'proname',
            label: '项目名称'
          },
          {
            value: 'proNumber',
            label: '项目编号'
          },
          {
            value: 'createDate',
            label: '创建时间'
          }
        ]
      } else if (this.state === 'task') {
        optionsKey = [
          {
            value: 'status',
            label: '任务状态'
          },
          {
            value: 'taskType',
            label: '任务类型'
          },
          {
            value: 'planStartDate',
            label: '计划开始时间'
          },
          {
            value: 'planEndDate',
            label: '计划截止时间'
          },
          {
            value: 'planWorkTime',
            label: '计划工期'
          },
          {
            value: 'createDate',
            label: '创建时间'
          },
          {
            value: 'updateDate',
            label: '更新时间'
          },
          {
            value: 'taskname',
            label: '任务名称'
          },
          {
            value: 'taskNumber',
            label: '任务编号'
          },
          {
            value: 'proNumber',
            label: '项目编号'
          }
        ]
      }
      this.addButt = false
      this.orderJson.push({
        key: '',
        sort: '',
        optionsKey: optionsKey
      })
    },
    // 点击加号
    addCond() {
      var optionsKey = []
      //  subject：项目；task：任务
      if (this.state === 'subject') {
        optionsKey = [
          {
            value: 'status',
            label: '项目状态'
          },
          {
            value: 'principalUser',
            label: '负责人'
          },
          {
            value: 'planStartDate',
            label: '计划开始时间'
          },
          {
            value: 'planEndDate',
            label: '计划截止时间'
          },
          {
            value: 'proname',
            label: '项目名称'
          },
          {
            value: 'proNumber',
            label: '项目编号'
          },
          {
            value: 'createDate',
            label: '创建时间'
          }
        ]
      } else if (this.state === 'task') {
        optionsKey = [
          {
            value: 'status',
            label: '任务状态'
          },
          {
            value: 'taskType',
            label: '任务类型'
          },
          {
            value: 'planStartDate',
            label: '计划开始时间'
          },
          {
            value: 'planEndDate',
            label: '计划截止时间'
          },
          {
            value: 'planWorkTime',
            label: '计划工期'
          },
          {
            value: 'createDate',
            label: '创建时间'
          },
          {
            value: 'updateDate',
            label: '更新时间'
          },
          {
            value: 'taskname',
            label: '任务名称'
          },
          {
            value: 'taskNumber',
            label: '任务编号'
          },
          {
            value: 'proNumber',
            label: '项目编号'
          }
        ]
      }
      var SortingType = false
      this.orderJson.map((date) => {
        if (date.key !== '') {
          optionsKey.map((item, index) => {
            if (item.value === date.key) {
              optionsKey.splice(index, 1)
            }
          })
        } else {
          SortingType = true
          this.$message.warning('请先选择排序类型')
        }
      })
      if (optionsKey.length > 0 && !SortingType) {
        this.orderJson.push({
          key: '',
          sort: '',
          optionsKey: optionsKey
        })
      }
    },
    // 获取焦点
    focusChange(row) {
      var optionsKey = []
      //  subject：项目；task：任务
      if (this.state === 'subject') {
        optionsKey = [
          {
            value: 'status',
            label: '项目状态'
          },
          {
            value: 'principalUser',
            label: '负责人'
          },
          {
            value: 'planStartDate',
            label: '计划开始时间'
          },
          {
            value: 'planEndDate',
            label: '计划截止时间'
          },
          {
            value: 'proname',
            label: '项目名称'
          },
          {
            value: 'proNumber',
            label: '项目编号'
          },
          {
            value: 'createDate',
            label: '创建时间'
          }
        ]
      } else if (this.state === 'task') {
        optionsKey = [
          {
            value: 'status',
            label: '任务状态'
          },
          {
            value: 'taskType',
            label: '任务类型'
          },
          {
            value: 'planStartDate',
            label: '计划开始时间'
          },
          {
            value: 'planEndDate',
            label: '计划截止时间'
          },
          {
            value: 'planWorkTime',
            label: '计划工期'
          },
          {
            value: 'createDate',
            label: '创建时间'
          },
          {
            value: 'updateDate',
            label: '更新时间'
          },
          {
            value: 'taskname',
            label: '任务名称'
          },
          {
            value: 'taskNumber',
            label: '任务编号'
          },
          {
            value: 'proNumber',
            label: '项目编号'
          }
        ]
      }
      row.optionsKey = optionsKey
      this.orderJson.map((date) => {
        row.optionsKey.map((item, index) => {
          if (item.value === date.key && row.key !== date.key) {
            row.optionsKey.splice(index, 1)
          }
        })
      })
    },
    // 选中
    selectChange(row) {
      row.sort = row.sort || 'desc'
    },
    // 点击减号
    delCond(index) {
      if (this.orderJson.length > 1) {
        this.orderJson.splice(index, 1)
      } else {
        this.orderJson = []
        this.addButt = true
        this.$emit('orderJson', this.orderJson)
      }
    },
    // 取消筛选
    reset() {
      if (this.sorting && this.sorting.length > 0) {
        this.orderJson = this.sorting
        this.addButt = false
      } else {
        this.orderJson = []
        this.addButt = true
      }
      this.visible = false
      this.$emit('orderJson', this.orderJson)
    },
    // 确定筛选
    screening() {
      // 类型
      var SortingType = false
      this.orderJson.map((date) => {
        console.log(date.key === '')
        if (date.key === '') {
          SortingType = true
          this.$message.warning('排序类型不能为空')
        }
      })
      if (!SortingType) {
        // this.$message.error(this.orderJson)
        this.visible = false
        this.$emit('orderJson', this.orderJson)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/index.scss';
.lyout {
  .main {
    margin: 10px 0;
    height: 185px;
    overflow-y: auto;
    .main-first {
      margin-top: 8px;
      display: flex;
      .sele-fist {
        width: 160px;
        height: 36px;
        margin-left: 23px;
      }
      .sele-secon {
        width: 230px;
        height: 36px;
        margin-left: 12px;
      }
      .iconfont {
        font-size: 24px;
        line-height: 44px;
        margin: 0 12px;
        &:hover {
          color: $color_main;
          cursor: pointer;
        }
      }
    }
  }
  .footer {
    position: absolute;
    left: 356px;
    bottom: 15px;
    .el-button {
      width: 73px;
      height: 36px;
    }
    .el-button--primary {
      color: $color_white;
      background: $color_main;
      border-color: $color_main;
    }
  }
}
// .moreSearch:hover {
//   .iconfont {
//     color: $color_main;
//   }
// }
// .el-button--info.is-plain {
//   background: #eeeeee;
// }

.more_btn .el-button--primary.is-plain {
  color: $color_main;
  border-color: $color_main;
  background: rgba(40, 120, 255, 0.1);
}
.more_btn .el-button:focus,
.more_btn .el-button:hover {
  color: $color_main;
  border-color: $color_main;
  background: rgba(40, 120, 255, 0.1);
}
.sea-icon {
  padding: 0 5px;
}
.el-button {
  height: 36px;
  line-height: 0;
}
.cond {
  width: 100%;
  .el-button {
    width: 100%;
  }
}
::v-deep .el-popover {
  padding: 0;
}
</style>
<style>
.el-popover.my-popover {
  padding: 0;
  height: 257px;
  position: relative;
}
</style>
